<template>
  <v-app>
    <v-sheet class="d-flex" height="100%">
      <Side v-if="sideSwitch" />
      <v-main class="adminCustomStyle" style="background: #f8f8f8">
        <v-btn
          style="position: fixed; top: 50%; transform: translateY(-50%); z-index: 5"
          :style="sideSwitch ? 'left:258px;' : 'left:4px;'"
          color="#313942"
          x-small
          depressed
          width="16"
          height="20"
          class="pa-0"
          @click="sideSwitch = !sideSwitch"
        >
          <v-icon color="white" size="16">
            {{ sideSwitch ? "mdi-chevron-left" : "mdi-chevron-right" }}
          </v-icon>
        </v-btn>
        <router-view :key="$route.fullPath"></router-view>
      </v-main>
    </v-sheet>
  </v-app>
</template>

<script>
import Side from "./Side"

export default {
  components: {
    Side,
  },

  data: () => ({
    sideSwitch: true,
  }),

  created() {
    const isAdminAuthRoute = this.$route.path.startsWith("/admin/auth")
    if (isAdminAuthRoute) {
      return
    }

    const lafiaUser = this.$store.state.lafia_user || {}
    const userType = (this.$store.getters.userType || "").toLowerCase()

    if (!lafiaUser.is_logined || !["admin", "staff"].includes(userType)) {
      this.$router.replace({
        path: "/admin/auth/login",
        query: { redirect: this.$route.fullPath },
      })
    }
  },
}
</script>
<style>
/* Flexible table 위해 */
.adminCustomStyle {
  width: 300px;
}

/* v-data-table 공통 스타일 */
.adminCustomStyle .theme--light.v-data-table {
  border: 1px solid #efefef;
}

.adminCustomStyle .theme--light.v-data-table > .v-data-table__wrapper > table {
  table-layout: fixed !important;
}

.adminCustomStyle .theme--light.v-data-table > .v-data-table__wrapper > table > tr > th {
  background: #f7f7f7;
  padding: 12px 10px;
  text-align: left;
  font-weight: medium;
  font-size: 12px;
  color: #555;
}

.adminCustomStyle .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 10px;
}

/* 세로선 */
.adminCustomStyle .theme--light.v-data-table > .v-data-table__wrapper > table > tr > th:not(:last-child),
.adminCustomStyle .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:not(:last-child) {
  border-right: 1px solid #efefef;
}
</style>
